import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { LibraryCreativesProvider } from "../../../../core/components/creatives/library/LibraryCreativesProvider";
import LibraryCreativesView from "../library/LibraryCreativesViewImproved";
import AdUnitDetail from "../pages/AdUnitDetailImproved";
import VideoUnitDetail from "../pages/VideoUnitDetailImproved";
import AdGroupDetail from "../pages/AdGroupDetailImproved";
import VideoAdGroupDetail from "../pages/VideoAdGroupDetailImproved";



const CreativesRoutes = (props) => {
  const { path } = props.match;

  return (
    <Switch>
      {/* RESTful main navigation routes */}
      <Route
        path={`${path}/display/units`}
        exact
        render={() => (
          <LibraryCreativesProvider {...props}>
            <LibraryCreativesView />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        path={`${path}/display/groups`}
        exact
        render={() => (
          <LibraryCreativesProvider {...props}>
            <LibraryCreativesView />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        path={`${path}/video/units`}
        exact
        render={() => (
          <LibraryCreativesProvider {...props}>
            <LibraryCreativesView />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        path={`${path}/video/groups`}
        exact
        render={() => (
          <LibraryCreativesProvider {...props}>
            <LibraryCreativesView />
          </LibraryCreativesProvider>
        )}
      />

      {/* Detail routes */}
      <Route
        exact
        path="/creatives/display/units/:id"
        render={({ match }) => (
          <LibraryCreativesProvider>
            <AdUnitDetail id={match.params.id} />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        exact
        path="/creatives/video/units/:id"
        render={({ match }) => (
          <LibraryCreativesProvider>
            <VideoUnitDetail id={match.params.id} />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        exact
        path="/creatives/display/groups/:id"
        render={({ match }) => (
          <LibraryCreativesProvider>
            <AdGroupDetail id={match.params.id} />
          </LibraryCreativesProvider>
        )}
      />
      <Route
        exact
        path="/creatives/video/groups/:id"
        render={({ match }) => (
          <LibraryCreativesProvider>
            <VideoAdGroupDetail id={match.params.id} />
          </LibraryCreativesProvider>
        )}
      />

      {/* Legacy main route redirect */}
      <Route
        path={`${path}/main/:pageNumber?`}
        exact
        render={() => <Redirect to={`${path}/display/units`} />}
      />

      {/* Legacy route redirects for backward compatibility */}
      <Route
        exact
        path="/creatives/AdUnit/:id"
        render={({ match }) => <Redirect to={`/creatives/display/units/${match.params.id}`} />}
      />
      <Route
        exact
        path="/creatives/VideoDetails/:id"
        render={({ match }) => <Redirect to={`/creatives/video/units/${match.params.id}`} />}
      />
      <Route
        exact
        path="/creatives/AdGroupDetail/:id"
        render={({ match }) => <Redirect to={`/creatives/display/groups/${match.params.id}`} />}
      />
      <Route
        exact
        path="/creatives/VideoGroupDetail/:id"
        render={({ match }) => <Redirect to={`/creatives/video/groups/${match.params.id}`} />}
      />

      {/* Fallback */}
      <Route path={`${path}`} render={() => <Redirect to={`${path}/display/units`} />} />
    </Switch>
  );
};

export default CreativesRoutes;
